var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('h2',{staticClass:"mb-4"},[_vm._v(_vm._s(_vm.$t('core.page_not_found')))]),_vm._v(" "),_c('div',{staticClass:"links"},[_c('router-link',{attrs:{"to":{ name: 'welcome' }}},[_vm._v("\n      "+_vm._s(_vm.$t('core.go_home'))+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }